export function authHeader(): Record<string, string> {
  try {
    // Lấy accessToken từ localStorage (token is already a string, no need to parse)
    const accessToken = localStorage.getItem('accessToken');
    
    if (accessToken) {
      return { Authorization: `Bearer ${accessToken}` };
    }
  } catch (error) {
    console.error('Error with accessToken:', error);
    // Clear invalid token
    localStorage.removeItem('accessToken');
  }
  
  return {};
}
